<template>
  <div>
    <!-- input -->
    <div class="flex flex-col md:flex-row gap-4 items-center w-full md:w-auto">
      <input
          v-model="code"
          class="input"
          placeholder="Type your promo here.."
          type="text"
      />
      <styled-button
          class="cursor-pointer transform hover:scale-105 w-full md:w-auto"
          @click="submitPromo"
      >
        apply
      </styled-button>
    </div>

    <!-- available code -->
    <div v-if="promo" class="text-primary mt-2">Applied code: <span
        class="font-semibold uppercase">{{ promo.code }}</span> (<span>{{ couponValue }}</span>)
    </div>
  </div>
</template>

<script>
import Api from '@/api/api_v1.0'
import StyledButton from '@/components/common/controls/StyledButton'

export default {
  components: { StyledButton },
  data () {
    return {
      code : '',
      promo: null,
    }
  },

  computed: {
    couponValue () {
      if (!this.promo) {
        return ''
      }

      if (this.promo.type == 'percent') {
        return `-${this.promo.amount}%`
      } else {
        return `-$${this.promo.amount}`
      }

    },
    order () {
      return this.$store.state.currentEditingOrder
    },
  },

  mounted () {
    this.loadPromo()
  },

  methods: {
    loadPromo () {
      Api.getOrderPromoCode(this.order.uuid).then(response => {
        this.promo = response.data
      })
    },
    async submitPromo () {
      try {
        await Api.applyPromoCodeToOrder(this.order.uuid, this.code)

        this.loadPromo()
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>
